/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sanction_Cat_Tournament_ErrorInputs */



/**
* | output |
* | --- |
* | "Tournament Error" |
*
* @param {Sanction_Cat_Tournament_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const sanction_cat_tournament_error = /** @type {((inputs?: Sanction_Cat_Tournament_ErrorInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sanction_Cat_Tournament_ErrorInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Erreur de Tournoi")
	if (locale === "es") return /** @type {LocalizedString} */ ("Error de Torneo")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Erro de Torneio")
	if (locale === "it") return /** @type {LocalizedString} */ ("Errore di Torneo")
	return /** @type {LocalizedString} */ ("Tournament Error")
});